///<reference path="../../../typings/angularjs/angular.d.ts"/>

module ProcessEditor {

    interface IChangeEvent {
        oldValue: string;
        newValue: string;
    }

    var eventName = 'name.change.frends';
    function escapeRegExp(str) {
        // from http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }

    export function frendsListenTaskNameChange($parse: ng.IParseService): ng.IDirective {
        return {
            restrict: "A",
            scope: false,
            link(scope: any, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ngModel) {
                var parseFunc = $parse(attributes['ngModel']); // use model expression bound to the input and parse a model accessor for it
                
                scope.$on(eventName, (event, data: IChangeEvent) => {
                    // get the value for the model property from the scope (parent scope is the one that contains the property we're accessing
                    var value = parseFunc(scope.$parent) || parseFunc(scope); // the default parameter editor uses scope.$parent, cobalt uses scope
                    var escapedOldValue = escapeRegExp(data.oldValue); // escape the name for use with regex
                    var regex = new RegExp("#RESULT((?:\\[" + escapedOldValue + "\\])|(?:\\." + escapedOldValue + "(?!\\w)))", "i");
                    var result = value.replace(regex, "#RESULT[" + data.newValue + "]");
                    if (value !== result) {
                        parseFunc.assign(scope.$parent, result);
                    }
                });

            }
        }
    }

    app.directive("frendsListenTaskNameChange", ["$parse", frendsListenTaskNameChange]);

    export function frendsNotifyTaskNameChange($rootScope: ng.IRootScopeService, $parse: ng.IParseService): ng.IDirective {
        return {
            restrict: "A",
            scope: false,
            link(scope: any, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ngModel) {
                var parseFunc = $parse(attributes['ngModel']);
                // we need to apply the parse func to the parent scope, because it is the one that contains the model
                // were making the assumption that the parent scope is the 
                var oldValue = parseFunc(scope.$parent);

                var nameForm = scope.NameForm; // get the name form for validity checks
                element.on('blur', function () {
                    var newValue = parseFunc(scope.$parent); // get the new value of the name input

                    if (oldValue === newValue || oldValue === "") {
                        if (nameForm.$valid) {
                            // require the name to be valid before updating the old value, this prevents duplicate task names from triggering notifications
                            oldValue = newValue; // update the oldValue so that new edits will trigger the change notification
                        }
                        
                        return; // the value wasn't updated or it was previously empty (new task or invalid)
                    }

                    if (nameForm.$valid) {
                        // the name validity is checked on each keypress, so it should always be validated before the element loses focus (blur)
                        $rootScope.$broadcast(eventName, <IChangeEvent>{ oldValue: <string>oldValue, newValue: <string>newValue });
                        oldValue = newValue; // update the oldValue to match the current one
                    }
                });
            }
        }
    }

    app.directive("frendsNotifyTaskNameChange", ["$rootScope", "$parse", frendsNotifyTaskNameChange]);
}